import {PropertyHouseStoreys} from "../../../offer/detail/constants/PropertyHouseStoreys";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const houseStoreys: ISearchFilterSlot<"house_storeys", string[]> = {
    id: "house_storeys",
    label: "Piętra",
    filters: [
        {
            id: "house_storeys",
            type: SearchFilterTypes.RADIO,
            filterOptions: [
                {id: "house_floor_option_single_storey", value: PropertyHouseStoreys.SINGLE_STOREY.toString(), label: "Parterowy"},
                {id: "house_floor_option_multi_storey", value: PropertyHouseStoreys.MULTI_STOREY.toString(), label: "Piętrowy"}
            ]
        }
    ]
};
import {PropertyHouseStoreys} from "../../../offer/detail/constants/PropertyHouseStoreys";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const houseStoreys: ISearchFilterSlot<"house_storeys", string[]> = {
    id: "house_storeys",
    label: "Piętra",
    filters: [
        {
            id: "house_storeys",
            type: SearchFilterTypes.RADIO,
            filterOptions: [
                {id: "house_floor_option_single_storey", value: PropertyHouseStoreys.SINGLE_STOREY.toString(), label: "Parterowy"},
                {id: "house_floor_option_multi_storey", value: PropertyHouseStoreys.MULTI_STOREY.toString(), label: "Piętrowy"}
            ]
        }
    ]
};
